(function () {
    angular.module('Directives').directive('bbaDriverDirectDetails', bbaDriverDirectDetails);
    bbaDriverDirectDetails.$inject = ['Units', '$rootScope'];
    function bbaDriverDirectDetails(Units, $rootScope) {
        return {
            restrict: 'E',
            require: '^form',
            templateUrl: '/templates/directives/components/margins/bba-driver-direct-details.html',
            scope: {
                service: '=',
                ngDisabled: '=isViewMode'
            },
            link: bbaDriverDirectDetailsCtrl
        };

        function bbaDriverDirectDetailsCtrl($scope, $element, $attribute, $ngModel) {
            $scope.shipmentTypes = ['regular', 'returns', 'both'];
            $scope.shipmentTypeLabels = {
                regular: 'Regular shipments',
                returns: 'Return Shipments',
                both: 'Regular and return shipments'
            };
            $scope.currentUser = $rootScope.GlobalProfile;
            $scope.currentUser.shortWeightUnit = Units.weightUnit.find(unit=>unit.value === $scope.currentUser.office.weightUnit).short.toUpperCase();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaDriverDirectDetails.js